<div class="footer-wrapper">
  <div class="footer-content">
    <div *ngFor="let item of menu" [ngClass]="getItemCssClasses(item.link)">
      <a [routerLink]="['/'+item.link]">
        <span class="mdi mdi-{{item.icon}}"></span>
        <span class="menu-title">
          {{item.title | translate}}
        </span>
      </a>
    </div>
  </div>
</div>
